/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerResponseData, FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerResponseDataFromJSONTyped, FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerResponseDataToJSON, } from './FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerResponseData';
export function FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponseDataFromJSON(json) {
    return FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponseDataFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerResponseData(json)) {
        return FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerResponseDataFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponseDataToJSON(json) {
    return FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponseDataToJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponseDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerResponseData(value)) {
        return FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerResponseDataToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponseData.js.map